import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";

const SchoolContext = createContext(null);

export function SchoolProvider({ children, user }) {
  const [school, setSchool] = useState(() => user?.school || null);

  useEffect(() => {
    if (user?.school) setSchool(user.school);
  }, [user?.school]);

  const setSchoolData = useCallback((userData) => {
    if (userData?.school) setSchool(userData.school);
  }, []);

  const clearSchool = useCallback(() => setSchool(null), []);

  const value = useMemo(() => ({
    school,
    setSchoolData,
    clearSchool,
    // Convenience getters
    schoolName:   school?.name   || "",
    schoolCode:   school?.code   || "",
    schoolBoard:  school?.board  || "",
    schoolLogo:   school?.logo   || null,
    grades:       school?.academic?.grades         || [],
    sections:     school?.academic?.sections       || [],
    classes:      school?.academic?.classes        || [],
    subjectsByGrade: school?.academic?.subjectsByGrade || [],
    workingDays:  school?.attendance?.workingDays  || [],
    attendanceMode: school?.attendance?.mode       || "once",
  }), [school, setSchoolData, clearSchool]);

  return <SchoolContext.Provider value={value}>{children}</SchoolContext.Provider>;
}

export function useSchool() {
  const ctx = useContext(SchoolContext);
  if (!ctx) throw new Error("useSchool must be used within SchoolProvider");
  return ctx;
}

export default SchoolContext;
